// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import VueTinySlider from "vue-tiny-slider";
import KonsiSliderItem from "./konsi_slider_item/KonsiSliderItem";
import KonsiDetailLayer from "../konsi_list_module/konsi_detail_layer/KonsiDetailLayer";

import { Api } from "#/api";
import { Pagination } from "#/common/interfaces/conversionworld/Pagination";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    VueTinySlider,
    KonsiSliderItem,
    KonsiDetailLayer,
  },
})
export class KonsiSliderModule extends ModuleBase {
  private slider: VueTinySlider;
  private container;

  private konsiProducts: any[] = [];
  private currentPage = 0;
  public pages = 0;
  public openKonsiDetail = false;
  public konsiItem;

  private elementClicked = false;
  private isDragging = false;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  created() {
    this.getProducts();
  }

  public async getProducts() {
    let productId =
      this.$store.page.page!.route_parameter["productId"] || undefined;

    let konsi = await Api.conversionWorldService.getKonsiProducts(
      this.$store.conversionWorldKonsiFilter.filter,
      0,
      9
    );

    this.konsiProducts = konsi.resultList;
    this.getSliderInfo();
  }

  public getSliderInfo() {
    Vue.nextTick(() => {
      this.slider = this.$refs.tinySlider;
      let info = this.slider.slider.getInfo();
      this.pages = info.pages;

      this.slider.slider.events.on("dragMove", this.onDragMove);
      this.slider.slider.events.on("dragEnd", this.onDragEnd);
    });
  }

  public onDragMove(info) {
    this.isDragging = true;
  }
  public onDragEnd() {
    this.isDragging = false;
  }

  public handleGoTo(action) {
    this.slider = this.$refs.tinySlider;
    this.slider.slider.goTo(action);
  }

  public handleOpenDetail(item) {
    if (!this.isDragging) {
      this.openKonsiDetail = !this.openKonsiDetail;
      this.$store.ui.setShowProductComparison(this.openKonsiDetail);
      this.konsiItem = item;
    }
  }
}
